import { render, staticRenderFns } from "./AdminStatsErrors.vue?vue&type=template&id=6571b032&"
import script from "./AdminStatsErrors.vue?vue&type=script&lang=js&"
export * from "./AdminStatsErrors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports